/**
 * Middleware, die überprüft, ob der Benutzer authentifiziert ist.
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
	const { isAuthenticated } = useAuth()
	const { amIOnboarded } = useUserMembership()

	console.debug({
		to: to.path,
		from: from.path,
		isAuthenticated: isAuthenticated.value,
		amIOnboarded: amIOnboarded.value,
	})

	if (!isAuthenticated.value && to.path !== RouteNames.ONBOARDING.LOGIN) {
		console.debug('User is not authenticated → navigating to login...')
		return navigateTo(RouteNames.ONBOARDING.LOGIN, { replace: true })
	}

	// If the user is authenticated and tries to access the login page, redirect to home
	if (isAuthenticated.value && amIOnboarded.value && (to.path !== RouteNames.INDEX) && from.path === RouteNames.ONBOARDING.LOGIN) {
		console.debug('User is authenticated and onboarded → navigating to home...')
		return navigateTo(RouteNames.INDEX, { replace: true })
	}
})
